import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_TRANSFERENCIAS_EXPORTADOR } from '../../../../../config/tables'

export default function TransferenciasExportadoresView () {
  return <MuiTable id={TABLA_TRANSFERENCIAS_EXPORTADOR} />
}
